import { MyUserGetViewModel } from '@api/v3';
import { FORM_DATE_FORMAT, formatISOToDate } from '@utils/dateUtil';

export const formatSavedContactsFields = (
  savedContacts: MyUserGetViewModel[] = []
) => {
  return savedContacts?.map((contact) => {
    return {
      ...contact,
      firstName: contact?.firstName?.trim(),
      lastName: contact?.lastName?.trim(),
      birthDate: contact?.birthDate
        ? formatISOToDate(contact.birthDate, FORM_DATE_FORMAT)
        : contact.birthDate,
    };
  });
};
